import type { ReactElement } from 'react';
import type { PoStatusFilter, PoTileCounts } from '../../domain/types';

interface PurchaseOrderTilesProps {
  counts: PoTileCounts;
  statusFilter: PoStatusFilter;
  onStatusFilter: (filter: PoStatusFilter) => void;
}

export function PurchaseOrderTiles({
  counts,
  statusFilter,
  onStatusFilter
}: PurchaseOrderTilesProps): ReactElement {
  return (
    <section className="tiles-grid">
      <article
        className={`tile ${statusFilter === 'all' ? 'tile-active' : ''}`}
        onClick={() => onStatusFilter('all')}
      >
        <h3>All</h3>
        <p>{counts.all}</p>
      </article>
      <article
        className={`tile ${statusFilter === 'created' ? 'tile-active' : ''}`}
        onClick={() => onStatusFilter('created')}
      >
        <h3>Unpaid</h3>
        <p>{counts.created}</p>
      </article>
      <article
        className={`tile ${statusFilter === 'paid' ? 'tile-active' : ''}`}
        onClick={() => onStatusFilter('paid')}
      >
        <h3>Paid</h3>
        <p>{counts.paid}</p>
      </article>
    </section>
  );
}
